import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { selectUserRole } from '../../reducers/userDataReducer'
import FilterItem from '../Filter/FilterItem'
import Icon from '../Icons'

const SideBuildingSelector = ({ selectedBuilding, buildings, onChange, showFullSelect }) => {
  const { t } = useTranslation(['chat'])
  const wrapperRef = useRef(null)
  const [isOpen, setOpen] = useState(false)
  const [search, setSearch] = useState('')

  const filteredOptions =
    buildings && buildings.length
      ? buildings.filter(
          (item) => !search || item.text.toLowerCase().includes(search.toLowerCase()),
        )
      : []

  const handleSelect = (item) => {
    onChange({ target: { name, value: item } })
    setOpen(false)
  }

  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  if (!selectedBuilding) return null
  return (
    <div className="side-building-selector">
      <div className="building-selector" onClick={() => setOpen(!isOpen)}>
        <img src={selectedBuilding.avatar} />
        {showFullSelect && (
          <React.Fragment>
            <div className="building-name">{selectedBuilding.text}</div>
            <Icon icon="arrow" viewBox="0 2 16 16" fill="#B5B4B4" />
          </React.Fragment>
        )}
      </div>
      {isOpen ? (
        <div
          ref={wrapperRef}
          className="ctp-dropdown__content--active ctp-dropdown__content--with-triangle"
        >
          <input
            className="ctp-dropdown__content-search"
            type="text"
            name="search"
            value={search}
            placeholder={t('chat:sideBuildingSelector.searchPlaceholder')}
            autoComplete="off"
            onChange={(e) => setSearch(e.target.value)}
          />
          <div className="ctp-dropdown__options">
            {filteredOptions.map((item, index) => {
              const itemProps = {
                item,
                index,
                variant: 'dropdown',
                isSelected: selectedBuilding.id === item.id,
                onSelect: handleSelect,
                controls: true,
                isFilter: false,
              }
              return <FilterItem key={item.id} {...itemProps} />
            })}
          </div>
        </div>
      ) : null}
    </div>
  )
}

SideBuildingSelector.propTypes = {
  showFullSelect: PropTypes.bool,
  selectedBuilding: PropTypes.object,
  buildings: PropTypes.array,
  onChange: PropTypes.func,
  userRole: PropTypes.string,
}

export default connect((state) => {
  return {
    userRole: selectUserRole(state),
  }
})(SideBuildingSelector)
